export default __webpack_public_path__ + "static/media/1887.2ad38e4e.png";